import { MonitoringService } from '../services';
import { ConfigurationProviderService } from '../services/configuration-provider.service';

export function appInitializer(configProvider: ConfigurationProviderService, monitoringService: MonitoringService) {
   return () => configProvider.load().then(config => {
      monitoringService.initialize(config.aiEndpointUrl, config.instrumentationKey);
   });
}